export const JWTExpiryThreshold = 1800; // Seconds
export const JWTRefreshSWRKey = "refresh-jwt";

export const DefaultHeaderSwapThreshold = 150;

export const HeaderArticleSpeechContainerElementID = "header-article-speech-container";
